import { StrapiTextualProps } from '@/features/strapi/components/textual';
import { StrapiImageTextualProps } from '@/features/strapi/components/image-textual';
import { StrapiTextualBlockProps } from '@/features/strapi/components/textual-block';
import { StrapiFeatureCardProps } from '@/features/strapi/components/feature-card';
import { StrapiCaseStudyCardProps } from '@/features/strapi/components/case-study-card';
import { StrapiMetricProps } from '@/features/strapi/components/metric';
import { StrapiIntegrationCardProps } from '@/features/strapi/components/integration-card';
import { StrapiReviewCardProps } from '@/features/strapi/components/review-card';
// @ts-ignore
import caseStudyPerson1 from '../assets/hp/b1.png';
// @ts-ignore
import caseStudyLogo1 from '../assets/hp/l1.png';
// @ts-ignore
import caseStudyPerson2 from '../assets/hp/b2.png';
// @ts-ignore
import caseStudyLogo2 from '../assets/hp/lg.png';
// @ts-ignore
import caseStudyPerson3 from '../assets/hp/b3.png';
// @ts-ignore
import caseStudyLogo3 from '../assets/hp/l3.png';
// @ts-ignore
import caseStudyPerson4 from '../assets/hp/b4.png';
// @ts-ignore
import caseStudyLogo4 from '../assets/hp/l4.png';

// @ts-ignore
import newFeature1 from '../assets/hp/p1.png';
// @ts-ignore
import newFeature2 from '../assets/hp/p2.png';
// @ts-ignore
import newFeature3 from '../assets/hp/p3.png';
// @ts-ignore
import newFeature4 from '../assets/hp/p4.png';
// @ts-ignore
import feature1Desktop from '../assets/d-feature-1.png';
// @ts-ignore
import feature2Desktop from '../assets/d-feature-2.png';
// @ts-ignore
import feature3Desktop from '../assets/d-feature-3.png';
// @ts-ignore
import feature4Desktop from '../assets/d-feature-4.png';
// @ts-ignore
import feature5Desktop from '../assets/d-feature-5.png';
// @ts-ignore
import feature6Desktop from '../assets/d-feature-6.png';
// @ts-ignore
import feature1Mobile from '../assets/m-feature-1.png';
// @ts-ignore
import feature2Mobile from '../assets/m-feature-2.png';
// @ts-ignore
import feature3Mobile from '../assets/m-feature-3.png';
// @ts-ignore
import feature4Mobile from '../assets/m-feature-4.png';
// @ts-ignore
import feature5Mobile from '../assets/m-feature-5.png';
// @ts-ignore
import feature6Mobile from '../assets/m-feature-6.png';
// @ts-ignore
import kidorimanLogo from '../assets/faherty_logo.png';
// @ts-ignore
import nectarLogo from '../assets/canopy_logo.png';
// @ts-ignore
import underoutfitLogo from '../assets/underoutfit.png';
// @ts-ignore
import tpjLogo from '../assets/theperfectblack.png';
// @ts-ignore
import kidorimanCaseStudyCover from '../assets/faherty_case_study_cover.png';
// @ts-ignore
import underoutfitCaseStudyCover from '../assets/underoutfit-case-study.png';
// @ts-ignore
import nectarCaseStudyCover from '../assets/canopy_case_study_cover.webp';
// @ts-ignore
import tpjCaseStudyCover from '../assets/jeans.png';
// @ts-ignore
import growthDevCost from '../assets/fudevicon.png';
// @ts-ignore
import growthAovCost from '../assets/radioicon.png';
// @ts-ignore
import growthCvrCost from '../assets/upicon.png';
// @ts-ignore
import integrationShopify from '../assets/integrations/integrations_shopify.png';
// @ts-ignore
import integrationShopifyPlus from '../assets/integrations/integrations_shopifyPlus.png';
// @ts-ignore
import integrationKlavio from '../assets/integrations/integrations_klaviyo.png';
// @ts-ignore
import integrationYotpo from '../assets/integrations/integrations_yotpo.png';
// @ts-ignore
import integrationMeta from '../assets/integrations/integrations_meta.png';
// @ts-ignore
import integrationHydrogen from '../assets/integrations/integrations_hydrogen.png';
// @ts-ignore
import integrationOkendo from '../assets/integrations/integrations_okendo.png';
// @ts-ignore
import integrationGa from '../assets/integrations/integrations_ga.png';
// @ts-ignore
import integrationInstagram from '../assets/integrations/integrations_instagram.png';
// @ts-ignore
import reviewsApricoat from '../assets/reviews/q_apricoat.png';
// @ts-ignore
import reviewsCozmo from '../assets/reviews/q_cozmo.png';
// @ts-ignore
import reviewsKarma from '../assets/reviews/q_karma.png';
// @ts-ignore
import reviewsMylee from '../assets/reviews/q_mylee.png';
// @ts-ignore
import reviewsSmartrike from '../assets/reviews/q_smarttrike.png';
// @ts-ignore
import reviewsViking from '../assets/reviews/q_viking.png';
// @ts-ignore
import reviewsMyname from '../assets/reviews/q_myname.png';
// @ts-ignore
import reviewsTPJ from '../assets/OvadiaImage.png';
// @ts-ignore
import fireIcon from '../assets/fireicon.png';

export const MainBannerContent = {
  title: {
    size: `5.2rem`,
    weight: `bold`,
    text: `Don't stop in traffic, convert it.`,
    mobileText: `Don't stop in\ntraffic, convert it.`,
    mobileMultiplier: 0.85,
    smMobileMultiplier: 0.8,
  } as StrapiTextualProps,
  teaser: {
    lineHeight: `1.8`,
    size: `2.8rem`,
    weight: `bold`,
    mobileMultiplier: 0.72,
    text: `The Shopify CRO Platform `,
    mobileText: `The Shopify CRO Platform`,
  } as StrapiTextualProps,
  subtitle: {
    lineHeight: `1.8`,
    size: `2.4rem`,
    mobileMultiplier: 0.72,
    text: `A/B test, Optimize, and Personalize every step of the way.
    Zero code, a ton of sales.`,
    mobileText: `A/B test, Optimize, and Personalize every step.
    Zero code, a ton of sales.`,
    smMobileMultiplier: 0.65,
  } as StrapiTextualProps,
  titleV2: {
    size: `4rem`,
    weight: `bold`,
    text: `The Most Powerful Testing\nand Personalization Platform`,
    mobileText: `The Most Powerful Testing\n and Personalization Platform`,
    mobileMultiplier: 0.6,
    smMobileMultiplier: 0.55,
  } as StrapiTextualProps,
  subtitleV2: {
    lineHeight: `1.8`,
    size: `2rem`,
    mobileMultiplier: 0.7,
    text: `We make it ridiculously simple to make smarter,\ndata-driven decisions`,
    mobileText: `We make it ridiculously simple to make smarter, \ndata-driven decisions`,
    smMobileMultiplier: 0.65,
  } as StrapiTextualProps,
  titleV3: {
    size: `2.8vw`,
    weight: `medium`,
    text: `Test more. Personalize\nsmarter. Learn why. `,
    mobileText: `Test more. Personalize\nsmarter. Learn why. `,
    xlMultiplier: 0.85,
    mobileMultiplier: 2.8,
    smMobileMultiplier: 2.4,
    lineHeight: `1.3`,
  } as StrapiTextualProps,
  subtitleV3: {
    lineHeight: `1.8`,
    size: `1.8rem`,
    mobileMultiplier: 0.8,
    xlMultiplier: 1.3,
    text: `AI trained on 62,000 real Shopify tests analyzes your store,\nbuilds the experience, merchandises the products and\ncreates the audience. Your team leads. Live in hours.`,
    mobileText: `AI trained on 62,000 real Shopify tests analyzes your store,\nbuilds the experience, merchandises the products and\ncreates the audience. Your team leads. Live in hours.`,
  } as StrapiTextualProps,
  getVisuallyButton: {
    className: `btn primary-btn`,
    href: `https://apps.shopify.com/visually-io?utm_source=Website+&utm_medium=HP`,
    text: `Get Visually for free`,
  },
  getExpertButton: {
    className: `btn secondary-btn`,
    href: `/public/talk-to-expert`,
    text: `Talk to an expert`,
  },
  benefitUsps: [
    {
      textual: {
        text: `Zero commitment`,
        size: `1.6rem`,
        mobileMultiplier: 0.9,
        xlMultiplier: 1.5,
      },
    },
    {
      textual: {
        text: `No code needed. Full control when you want it.`,
        size: `1.6rem`,
        mobileMultiplier: 0.9,
        xlMultiplier: 1.5,
      },
    },
  ] as StrapiImageTextualProps[],
  featuresHighlights: [
    {
      title: { text: `Next-gen Visual Editor`, size: `2rem`, weight: `bold` },
      description: {
        text: `This innovative editor that\nharnesses the power of a robust AI\nscanner, enables you to effortlessly\ncraft sophisticated shopping\nexperiences`,
        size: `1.6rem`,
        weight: `light`,
        lineHeight: `1.7`,
      },
    },
    {
      title: { text: `Go Live Faster`, size: `2rem`, weight: `bold` },
      description: {
        text: `Shorten the path from vision to\nexecution, go live faster, test and\noptimize on the fly. Stay agile, like your\nbusiness, no development required.`,
        size: `1.6rem`,
        weight: `light`,
        lineHeight: `1.7`,
      },
    },
    {
      title: { text: `Reduce Costs`, size: `2rem`, weight: `bold` },
      description: {
        text: `Get the power of code and stay on-\nbrand without hiring any developers or\ndesigners, while A/B testing every move.`,
        size: `1.6rem`,
        weight: `light`,
        lineHeight: `1.7`,
      },
    },
    {
      title: { text: `All-in-one Platform`, size: `2rem`, weight: `bold` },
      description: {
        text: `Centralize your entire on-site\nmarketing stack within a single robust\nplatform. Test, optimize, personalize,\nand upsell seamlessly. Harnessing the\nfull potential of first-party data.`,
        size: `1.6rem`,
        weight: `light`,
        lineHeight: `1.7`,
      },
    },
  ] as StrapiTextualBlockProps[],
  trustedBy: {
    lineHeight: `1.3`,
    weight: `medium`,
    size: `3.2rem`,
    mobileMultiplier: 1,
    xlMultiplier: 1.3,
    text: `They didn't take our word for it either.`,
    mobileText: `They didn't take \nour word for it either.`,
  } as StrapiTextualProps,
};

export const FeaturesContent = {
  title: {
    size: `4.3rem`,
    weight: `bold`,
    text: `Next-generation CRO Platform\nfueled by data and AI`,
    mobileText: `Next-generation CRO Platform\nfueled by data and AI`,
    smMobileMultiplier: 0.5,
  } as StrapiTextualProps,
  features: [
    {
      title: {
        text: `Intuitive Personalization`,
        size: `2rem`,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Ensure your homepage experience is equally\ntailored to each visitor.`,
        mobileText: `Ensure your homepage\nexperience is equally\ntailored to each visitor.`,
        size: `1.7rem`,
        weight: `light`,
        mobileMultiplier: 0.8,
      },
      image: feature1Desktop,
      mobileImage: feature1Mobile,
      width: `70rem`,
    },
    {
      title: {
        text: `Behavioral targeting`,
        size: `2rem`,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Optimize the shopper journey utilizing smart data on\nbehavior and interests`,
        mobileText: `Optimize the shopper journey utilizing smart\ndata on behavior and interests`,
        size: `1.7rem`,
        weight: `light`,
        mobileMultiplier: 0.8,
      },
      image: feature2Desktop,
      mobileImage: feature2Mobile,
      width: `50rem`,
    },
    {
      title: {
        text: `On-site Retention automation`,
        size: `2rem`,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Display "Buy Again" to recognize repeating customers`,
        size: `1.7rem`,
        weight: `light`,
        mobileMultiplier: 0.8,
      },
      image: feature3Desktop,
      mobileImage: feature4Mobile,
      width: `50rem`,
    },
    {
      title: {
        text: `AI-fueled Upsells`,
        size: `2rem`,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Intelligently recommend complementary\nproducts at any stage of the shopper journey`,
        mobileText: `Intelligently recommend\ncomplementary\nproducts at any stage\nof the shopper journey`,
        size: `1.7rem`,
        weight: `light`,
        mobileMultiplier: 0.8,
      },
      image: feature4Desktop,
      mobileImage: feature3Mobile,
      width: `70rem`,
    },
    {
      title: {
        text: `No-Code A/B Testing Optimization`,
        size: `2rem`,
        mobileMultiplier: 0.7,
      },
      image: feature5Desktop,
      mobileImage: feature5Mobile,
      width: `44rem`,
    },
    {
      title: {
        text: `Smart recommendations`,
        size: `2rem`,
        mobileMultiplier: 0.8,
      },
      image: feature6Desktop,
      mobileImage: feature6Mobile,
      width: `76rem`,
    },
  ] as StrapiFeatureCardProps[],
  footer: {
    textual: {
      text: `Zero impact on site speed; Zero flickering`,
      size: `2.7rem`,
      mobileMultiplier: 0.6,
      smMobileMultiplier: 0.55,
    },
    image: fireIcon,
    gap: `2rem`,
  } as StrapiImageTextualProps,
};

export const FeaturesContentV3 = {
  title: {
    size: `3.7rem`,
    weight: `medium`,
    text: `A smarter way to drive growth across the\nshopper experience`,
    mobileText: `A smarter way to drive growth\nacross the shopper experience`,
    smMobileMultiplier: 0.55,
    mobileMultiplier: 0.7,
    xlMultiplier: 1.3,
    lineHeight: `1.2`,
  } as StrapiTextualProps,
  features: [
    {
      title: {
        text: `Full-funnel Testing`,
        size: `2.2rem`,
        weight: `medium`,
        xlMultiplier: 1.3,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Iterate anywhere with Visually AI, creating the tests you want in
minutes. From first click to checkout and beyond, uncover
the customer journeys that drive conversions and revenue`,
        size: `1.8rem`,
        xlMultiplier: 1.2,
        lineHeight: `1.5`,
        mobileMultiplier: 0.8,
        weight: `light`,
      },
      image: newFeature1,
      mobileImage: newFeature1,
      width: `70rem`,
    },
    {
      title: {
        text: `Personalization`,
        size: `2.2rem`,
        weight: `medium`,
        xlMultiplier: 1.3,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Create hyper-personalized experiences with catalog and behavior
-powered smart segmentation that drives revenue. Create the right
experience, for the right shopper, at the right time`,
        size: `1.8rem`,
        xlMultiplier: 1.2,
        lineHeight: `1.5`,
        mobileMultiplier: 0.8,
        weight: `light`,
      },
      image: newFeature2,
      video: `https://iframe.mediadelivery.net/embed/162751/074af42f-31dc-4351-b0b4-6d63b5b2d3a7?autoplay=true&loop=true&muted=true&preload=true&responsive=true`,
    },
    {
      title: {
        text: `Merchandising and Upselling`,
        size: `2.2rem`,
        weight: `medium`,
        xlMultiplier: 1.3,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Use sophisticated logic including 12+ pre-built algorithms, and deep
Shopify catalog integration to make every stage of the shopping
journey part of a dynamic merchandising engine`,
        size: `1.8rem`,
        lineHeight: `1.5`,
        xlMultiplier: 1.2,
        mobileMultiplier: 0.8,
        weight: `light`,
      },
      image: newFeature3,
      video: `https://iframe.mediadelivery.net/embed/162751/f28e0497-f742-40ec-9acd-da2bf896019f?autoplay=true&loop=true&muted=true&preload=true&responsive=true`,
    },
    {
      title: {
        text: `Powerful Analytics`,
        size: `2.2rem`,
        weight: `medium`,
        xlMultiplier: 1.3,
        mobileMultiplier: 0.8,
      },
      description: {
        text: `Make fast decisions with a Bayesian engine and visual event
tracking. Interact with analytics to understand profitability, returns,
subscriptions, and more Shopify-native KPIs`,
        size: `1.8rem`,
        lineHeight: `1.5`,
        xlMultiplier: 1.2,
        mobileMultiplier: 0.8,
        weight: `light`,
      },
      image: newFeature4,
    },
  ] as StrapiFeatureCardProps[],
  extraFeaturesTitle: {
    size: `2.2rem`,
    weight: `light`,
    text: `Optimize Every Shopper Journey`,
    style: { textTransform: `uppercase` },
    smMobileMultiplier: 0.5,
    xlMultiplier: 1.1,
  } as StrapiTextualProps,
  extraFeatures: [
    `AI Component Generation`,
    `Image to Component`,
    `Content Blocks`,
    `Page Editing`,
    `On-site Automations`,
    `Price Testing`,
    `Timers`,
    `Theme Testing`,
    `Redirect Tests`,
    `Shipping Tests`,
    `Post-purchase Offers`,
    `Apps Impact Tests`,
    `Checkout Blocks`,
    `Sale Boosters`,
    `Social Proof`,
    `Personalized Upsells`,
    `Recommendations`,
  ],
};

export const CaseStudiesContent = {
  title: {
    size: `4.3rem`,
    weight: `medium`,
    mobileMultiplier: 0.6,
    smMobileMultiplier: 0.55,
    text: `The most disruptive brands choose Visually to\nboost their sales and revenue`,
    mobileText: `The most disruptive brands\nchoose Visually to boost\ntheir sales and revenue`,
  } as StrapiTextualProps,
  caseStudies: [
    {
      bigTitle: {
        size: `5rem`,
        weight: `bold`,
        text: `+42%`,
      } as StrapiTextualProps,
      title: {
        size: `2.5rem`,
        weight: `bold`,
        text: `CVR Uplift`,
        mobileText: `CVR Uplift`,
      } as StrapiTextualProps,
      logoImage: underoutfitLogo,
      coverImage: underoutfitCaseStudyCover,
      link: `/public/case-studies/underoutfit`,
      teaser: {
        mobileMultiplier: 0.8,
        weight: `light`,
        size: `1.8rem`,
        text: `“Visually is a truly revolutionary tool.
Its ability to personalize the user experience,
conduct tests, and create different experiences
has completely transformed our approach.
The ease of use, without requiring any technical
knowledge, is a godsend for marketers and
CX professionals. We are completely hooked on it.”

Felix Lensho, Co-founder & CMO, Underoutfit
`,
        mobileText: `“Visually is a truly revolutionary tool.
Its ability to personalize the user experience,
conduct tests, and create different experiences
has completely transformed our approach.
The ease of use, without requiring any technical
knowledge, is a godsend for marketers and
CX professionals. We are completely hooked on it.”

Felix Lensho, Co-founder & CMO, Underoutfit
`,
      },
    },
    {
      bigTitle: {
        size: `5rem`,
        weight: `bold`,
        text: `+18%`,
      } as StrapiTextualProps,
      title: {
        size: `2.5rem`,
        weight: `bold`,
        text: `Increase in CVR`,
      } as StrapiTextualProps,
      logoImage: tpjLogo,
      coverImage: tpjCaseStudyCover,
      link: `/public/case-studies/tpj`,
      teaser: {
        weight: `light`,
        size: `1.8rem`,
        mobileMultiplier: 0.8,
        text: `“Visually is an incredible app that has
replaced 3-4 other apps (upsells, A/B testing,
code editing, landing pages and more).
It works as expected, has minimal
impact on page speed, and the feature set
and ease of use is really spot on.”

Ovadia Labaton CEO, The Perfect Jean
`,
        mobileText: `“Visually is an incredible app that has
replaced 3-4 other apps (upsells, A/B testing,
code editing, landing pages and more).
It works as expected, has minimal
impact on page speed, and the feature set
and ease of use is really spot on.”

Ovadia Labaton CEO, The Perfect Jean
`,
      },
    },
    {
      bigTitle: {
        size: `5rem`,
        weight: `bold`,
        text: `+33%`,
      } as StrapiTextualProps,
      title: {
        size: `2.5rem`,
        weight: `bold`,
        text: `Increase in CVR`,
      } as StrapiTextualProps,
      logoImage: nectarLogo,
      coverImage: nectarCaseStudyCover,
      link: `/public/case-studies/canopy`,
      teaser: {
        weight: `light`,
        size: `1.8rem`,
        mobileMultiplier: 0.75,
        text: `“Whenever I talk to people about Visually they say:
I didn’t even know you could do that to a website,
that every element just becomes movable or editable.
That’s the biggest thing for me - a quick and simple way
for us to test internally.
Not to mention, the team’s support is just so great.
The CRO expert actually bring things for us
to think about, along with suggestions to test -
they genuinely want to see us grow and succeed”

Anastasia Postolati,
Ecommerce Manager
`,
        mobileText: `“Whenever I talk to people about Visually they say:
I didn’t even know you could do that to a website,
every element just becomes movable or editable.
Not to mention, the team’s support is just so great.
The CRO expert actually bring things for us
to think about, along with suggestions to test -
they genuinely want to see us grow and succeed”

Anastasia Postolati, Ecommerce Manager
`,
      },
    },
    {
      bigTitle: {
        size: `5rem`,
        weight: `bold`,
        text: `+18%`,
      } as StrapiTextualProps,
      title: {
        size: `2.5rem`,
        weight: `bold`,
        text: `Increase in Revenue per Session`,
        mobileText: `in Revenue per Session`,
      } as StrapiTextualProps,
      logoImage: kidorimanLogo,
      coverImage: kidorimanCaseStudyCover,
      link: `/public/case-studies/faherty`,
      teaser: {
        weight: `light`,
        size: `1.8rem`,
        mobileMultiplier: 0.8,
        text: `“Something that I found extremely rewarding is how
Visually has helped us execute promotions and
experiences targeting specific groups of customers,
showing them a unique creative while the rest of
our site just remains business as usual.
So for example, we’ve run VIP only sales where all
shoppers can obviously still access our website,
but only a certain group,
those identified from a specific UTM, will be
directed to the Visually powered experience.
The team has just been so impressed with that -
it has been so much better than the VIP sales
we’ve tried to execute in the past”

Kirsten Kaminski,
Site Merchandizing Associate
`,
        mobileText: `“Visually has helped us execute promotions and
targeting specific groups of customers,
showing them a unique creative while the rest of
our site just remains business as usual.
For example all VIP's directed to the
Visually powered experience while other
shoppers were able to access our website as usual.”

Kirsten Kaminski, Site Merchandizing Associate
`,
      },
    },
  ] as StrapiCaseStudyCardProps[],
  growthTitle: {
    size: `4rem`,
    weight: `medium`,
    text: `Your growth is guaranteed`,
    smMobileMultiplier: 0.65,
  } as StrapiTextualProps,
  growthMetrics: [
    {
      metricName: `In Conversion Rate`,
      metricValue: `2X`,
      metricImage: growthCvrCost,
    },
    {
      metricName: `In Average Order Value`,
      metricValue: `+20%`,
      metricImage: growthAovCost,
    },
    {
      metricName: `In Development Cost`,
      metricValue: `-99%`,
      metricImage: growthDevCost,
    },
  ] as StrapiMetricProps[],
  growthCta: {
    size: `1.8rem`,
    text: `Get started free`,
    className: `btn primary-btn`,
    href: `https://apps.shopify.com/visually-io?utm_source=Website+&utm_medium=HP`,
  } as StrapiTextualProps,
  growthSubtitle: {
    size: `1.85rem`,
    text: `Real numbers, Zero effort, Zero commitment`,
    mobileMultiplier: 0.9,
  } as StrapiTextualProps,
};

export const CaseStudiesContentV3 = {
  title: {
    size: `3.7rem`,
    weight: `medium`,
    mobileMultiplier: 0.7,
    text: `How the best brands optimize their\nShopify conversions`,
    mobileText: `How the best brands optimize\n their Shopify conversions`,
  } as StrapiTextualProps,
  caseStudies: [
    {
      logo: caseStudyLogo1,
      text: {
        size: `2.2rem`,
        xlMultiplier: 1.2,
        weight: `light`,
        lineHeight: `1.8`,
        text: `"We've run VIP only sales for a certain group, who
will be directed to the Visually powered
experience. it has been so much better than the
VIP sales we've tried to execute in the past"`,
      } as StrapiTextualProps,
      link: {
        size: `1.6rem`,
        xlMultiplier: 1.2,
        text: `Read the full case study >`,
        href: `https://visually.io/public/case-studies/faherty`,
        openInNewTab: true,
        mobileMultiplier: 0.9,
      } as StrapiTextualProps,
      person: {
        image: caseStudyPerson1,
        name: `Kristen Kaminski`,
        title: `Site Merchandising Associate`,
      },
    },
    {
      logo: caseStudyLogo4,
      text: {
        size: `2.2rem`,
        xlMultiplier: 1.2,
        weight: `light`,
        lineHeight: `1.8`,
        text: `"With Visually, we can go from an idea to
launching a new experience in minutes - it's truly
incredible. We've been able to roll out so many
tests in such a short amount of time"`,
      } as StrapiTextualProps,
      link: {
        size: `1.6rem`,
        xlMultiplier: 1.2,
        text: `Read the full case study >`,
        href: `https://visually.io/public/case-studies/bonfide`,
        openInNewTab: true,
        mobileMultiplier: 0.9,
      } as StrapiTextualProps,
      person: {
        image: caseStudyPerson2,
        name: `Nargiza Dakmak`,
        title: `Director of E-commerce`,
      },
    },
    {
      logo: caseStudyLogo2,
      text: {
        size: `2.2rem`,
        xlMultiplier: 1.2,
        weight: `light`,
        lineHeight: `1.8`,
        text: `"Something that I found extremely rewarding is
how Visually helps us execute promotions and
experiences targeting specific customers, while
the rest of our site is business as usual"`,
      } as StrapiTextualProps,
      link: {
        size: `1.6rem`,
        xlMultiplier: 1.2,
        text: `Read the full case study >`,
        href: `/public/case-studies/laura-geller`,
        openInNewTab: true,
        mobileMultiplier: 0.9,
      } as StrapiTextualProps,
      person: {
        image: caseStudyPerson3,
        name: `Harry Roth`,
        title: `Director of E-commerce`,
      },
    },
    {
      logo: caseStudyLogo3,
      text: {
        size: `2.2rem`,
        xlMultiplier: 1.2,
        weight: `light`,
        lineHeight: `1.8`,
        text: `"Visually's visual editor tool makes it incredibly
easy to launch new tests and iterations rapidly,
and their targeting and filtering tech allows for
deep customization and personalization."`,
      } as StrapiTextualProps,
      link: {
        size: `1.6rem`,
        xlMultiplier: 1.2,
        text: `Read the full case study >`,
        href: `https://visually.io/public/case-studies/fct`,
        openInNewTab: true,
        mobileMultiplier: 0.9,
      } as StrapiTextualProps,
      person: {
        image: caseStudyPerson4,
        name: `Dan Silverman`,
        title: `Senior E-commerce Product Manager`,
      },
    },
  ],
};

export const IntegrationsContent = {
  title: {
    size: `4.3rem`,
    weight: `bold`,
    text: `Built for Shopify`,
  } as StrapiTextualProps,
  subtitle: {
    size: `2.8rem`,
    weight: `normal`,
    text: `Integrated with your full stack`,
    style: { letterSpacing: `-0.8px` },
  } as StrapiTextualProps,
  integrations: [
    {
      image: integrationShopify,
      text: `Seamlessly integrated with Shopify. By
adding Visually to your store you can
effortlessly elevate your On-Site Marketing
with the robust visual editor for no-code
experience building.`,
    },
    {
      image: integrationShopifyPlus,
      text: `Integrate Shopify Plus with Visually in a
single click. With Visually's Shopify Plus
Integration, you can accelerate growth
with the most advanced suite of solutions
for On-site Marketing.`,
    },
    {
      image: integrationKlavio,
      text: `Using Visually with Klaviyo, you can
personalize the user experience. If a
customer signs up for a promotion in
Klaviyo, Visually.io displays the specific
offer they chose, enhancing engagement`,
    },
    {
      image: integrationYotpo,
      text: `By integrating with Yotpo Loyalty, you
can target loyal customers and
incorporate a fast sign-up component,
potentially boosting loyalty registration
by over 50% `,
    },
    {
      image: integrationMeta,
      text: `By integrating with Meta Campaigns, you
can target specific campaigns without
UTMs, fetching campaign content directly
into Visually to craft the best experience
for paid visitors`,
    },
    {
      image: integrationHydrogen,
      text: `By integrating with Shopify Hydrogen, we
enable customers who've transitioned to
headless to effortlessly harness Visually's
full capabilities and seamlessly revive their
optimized experiences`,
    },
    {
      image: integrationOkendo,
      text: `By integrating with Okendo, you can
emphasize product ratings in
recommendations and effortlessly visually
edit the reviews section.`,
    },
    {
      image: integrationGa,
      text: `While we provide comprehensive analysis
reports for every active experience or A/B
test, we also offer the capability to sync
experiment events with GA4 for deeper
insights`,
    },
    {
      image: integrationInstagram,
      text: `With the Visually-Instagram integration,
you can directly display content from your
Instagram within the added Visually
components`,
    },
  ] as StrapiIntegrationCardProps[],
  footer: {
    size: `2.3rem`,
    weight: `normal`,
    text: `And much more`,
  } as StrapiTextualProps,
};

export const ReviewsContent = {
  title: {
    size: `4.3rem`,
    weight: `medium`,
    text: `Don't just take our word for it.`,
    mobileText: `Don't just take our\nword for it.`,
    mobileMultiplier: 0.6,
  } as StrapiTextualProps,
  reviews: [
    {
      href: `https://mylee.co.uk/`,
      store: `Mylee`,
      image: reviewsMylee,
      text: `Been using visually around 6 months now and
we are seeing very good results. The tool,
company and people are very professional and
very happy from A-Z. The tool is insane! you can
get anything live within seconds on the site
which is a game changer. And dont forget you
can add widget wherever you want without a
dev support! We really gamed up with Visually!
thanks so much and more to come of course`,
    },
    {
      href: `https://apricoat.com/`,
      store: `Apricoat`,
      image: reviewsApricoat,
      text: `This platform is Super useful for any
customization, a/b testing, setting up pages for
specific traffic, upsells, timers, and many more..
it's very user friendly and the customer service
is very helpful...
my guess is that they will keep on growing, fast.`,
    },
    {
      href: `https://www.mynamenecklace.co.il/`,
      store: `MyNameNecklace`,
      image: reviewsMyname,
      text: `Visually.io improve our site funnel!
with many great customer Experiences, Great
and Easy Working flow. Easy Testing flow to
check what can have the bigger impact on
customers! many very easy tools to improve
CVR and customer site flow.
Great Customers Support and help with any
issue. Highly Recommended!`,
    },
    {
      href: `https://www.karmaandluck.com/`,
      store: `Karma And Luck`,
      image: reviewsKarma,
      text: `Visually is hands down one of the best apps
we've been using to keep a competitive edge
across all areas of our marketing, tech and
strategy stack. Visually is an absolute game
changer that allows us to craft the perfect
personalized user experience, split and a/b test
new concepts and ideas and deploy new
features exceptionally quickly and efficiently. `,
    },
    {
      href: `https://www.mycozmo.com/`,
      store: `Cozmo`,
      image: reviewsCozmo,
      text: `What a great app!
Easy to use, superb customer service,
game-changing features, insightful analytics any more.
I'm now A/B testing EVERYTHING!
(and my store looks so much better)
Highly recommended`,
    },
    {
      href: `https://www.smartrike.com/`,
      store: `SmarTrike`,
      image: reviewsSmartrike,
      text: `Been super important for my performance
throughout Q4! lifesaver. You can work with it without
prior knowledge in coding or design, no need for any
day to day use of developers. Very recommended!`,
    },
    {
      href: `https://vikingrevolution.com//`,
      store: `Viking Revolution`,
      image: reviewsViking,
      text: `The team at Visually.io went above and beyond
to help us implement all the features the software
has to offer. Sales increased immediately with the a/b
testing and the experiences they helped create for
our customers. Key thing is NO programming necessary,
and the team can react quickly and implement
winning strategies.
Best investment we have done for our site!`,
    },
    {
      href: `https://theperfectjean.nyc/`,
      store: `The Perfect Jean`,
      image: reviewsTPJ,
      author: `Ovadia Labaton`,
      job: `CEO, The Perfect Jean NYC`,
      text: `Visually is an *incredible* app that has
replaced 3-4 other apps (upsells, A/B testing,
code editing, landing pages and more).
It works as expected, has minimal impact on page
speed, and the feature set and ease of use
is really spot on.
Most important - the team is SUPER helpful and smart.
We're really really happy with it and Visually is
driving huge value for us.`,
    },
  ] as StrapiReviewCardProps[],
};

export const DisruptContent = {
  title: {
    size: `4.3rem`,
    weight: `medium`,
    text: `Start testing at the speed of commerce`,
    mobileText: `Start testing at the\nspeed of commerce`,
  } as StrapiTextualProps,
  getVisuallyButton: {
    href: `https://apps.shopify.com/visually-io?utm_source=Website+&utm_medium=HP`,
    text: `Get started for free`,
  },
  getExpertButton: {
    href: `/public/talk-to-expert`,
    text: `Talk to an expert`,
  },
  benefitUsps: [
    { text: `Instant Setup`, size: `1.8rem` },
    { text: `Free trial`, size: `1.8rem` },
    { text: `Zero commitment`, size: `1.8rem` },
  ] as StrapiTextualProps[],
};
